import { render, staticRenderFns } from "./MysteryBoxRewardDialog.vue?vue&type=template&id=02aebd8e&scoped=true&"
import script from "./MysteryBoxRewardDialog.vue?vue&type=script&lang=js&"
export * from "./MysteryBoxRewardDialog.vue?vue&type=script&lang=js&"
import style0 from "./MysteryBoxRewardDialog.vue?vue&type=style&index=0&id=02aebd8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aebd8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
